import React from "react";

const ErrorDisplay = ({ error, onRetry }) => {
  if (!error) return null;

  const containerStyle = {
    backgroundColor: "#f8d7da",
    color: "#721c24",
    padding: "15px 20px",
    borderRadius: "8px",
    border: "1px solid #f5c6cb",
    margin: "20px 0",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  };

  const messageStyle = {
    fontSize: "16px",
    fontWeight: "500",
    flex: 1,
  };

  const buttonStyle = {
    padding: "8px 16px",
    backgroundColor: "#dc3545",
    color: "white",
    border: "none",
    borderRadius: "4px",
    cursor: "pointer",
    fontSize: "14px",
    fontWeight: "500",
    marginLeft: "15px",
  };

  return (
    <div style={containerStyle}>
      <div style={messageStyle}>Eroare: {error.toString()}</div>
      {onRetry && (
        <button
          style={buttonStyle}
          onClick={onRetry}
          onMouseEnter={(e) => (e.target.style.backgroundColor = "#c82333")}
          onMouseLeave={(e) => (e.target.style.backgroundColor = "#dc3545")}
        >
          Incearca din nou
        </button>
      )}
    </div>
  );
};

export default ErrorDisplay;
